(() => {
  const init = () => {
    document.querySelectorAll('[data-eo-collection]').forEach(root => {
      if (root.dataset.eoReady) return;
      const description = root.querySelector('[data-eo-description]');
      const buyingGuide = root.querySelector('[data-eo-buying-guide]');
      const firstDetails = description?.querySelector('details');
      if (firstDetails && buyingGuide) {
        const range = document.createRange();
        range.setStartBefore(firstDetails);
        range.setEnd(description, description.childNodes.length);
        const guideContent = buyingGuide.querySelector('[data-eo-guide-content]');
        guideContent.append(range.extractContents());
        guideContent.querySelectorAll('[id]').forEach(node => {
          if (document.getElementById(node.id) !== node) node.removeAttribute('id');
        });
        buyingGuide.hidden = false;
        const introCopy = description.cloneNode(true);
        introCopy.querySelectorAll('style,script').forEach(node => node.remove());
        if (!introCopy.textContent.trim() && !introCopy.querySelector('img,video,iframe')) {
          root.querySelector('[data-eo-intro-guide]').hidden = true;
        }
      }
      root.dataset.eoReady = 'true';
      const filterToggle = root.querySelector('[data-eo-toggle-filters]');
      filterToggle.addEventListener('click', () => { const expanded = filterToggle.getAttribute('aria-expanded') !== 'true'; filterToggle.setAttribute('aria-expanded', String(expanded)); root.querySelector('[data-eo-filters]').classList.toggle('eo-filters--expanded', expanded); });
      root.querySelectorAll('[data-eo-tag-filter]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); const target = new URL(link.href); const params = new URLSearchParams(location.search); params.delete('page'); target.search = params.toString(); location.assign(target); }));
      const strings = JSON.parse(root.querySelector('[data-eo-strings]').textContent);
      const products = new Map();
      root.querySelectorAll('[data-eo-product]').forEach(node => {
        const data = JSON.parse(node.textContent);
        products.set(String(data.id), data);
      });
      const selection = new Map();
      const bar = root.querySelector('.eo-compare-bar');
      const announcement = root.querySelector('[data-eo-announcement]');
      const dialog = root.querySelector('dialog');
      const openButton = root.querySelector('[data-eo-open-compare]');
      const closeButton = root.querySelector('[data-eo-close]');
      const update = () => {
        bar.hidden = !selection.size;
        root.querySelector('[data-eo-selection]').textContent = strings.selected.replace('[count]', selection.size);
        openButton.disabled = selection.size < 2;
      };
      root.querySelectorAll('.eo-compare-select').forEach(label => { label.hidden = label.querySelector('input').disabled; });
      root.querySelectorAll('[data-eo-compare]').forEach(input => {
        input.checked = false;
        input.addEventListener('change', () => {
          const id = input.dataset.eoCompare;
          if (input.checked && selection.size && [...selection.values()][0].family !== products.get(id).family) { input.checked = false; announcement.textContent = strings.family_mismatch; return; }
          if (input.checked && selection.size === 3) {
            input.checked = false;
            announcement.textContent = strings.limit;
            return;
          }
          if (input.checked) selection.set(id, products.get(id));
          else selection.delete(id);
          announcement.textContent = '';
          update();
        });
      });
      root.querySelector('[data-eo-clear]').addEventListener('click', () => {
        selection.clear();
        root.querySelectorAll('[data-eo-compare]').forEach(input => { input.checked = false; });
        update();
      });
      const cell = (tag, text) => { const node = document.createElement(tag); node.textContent = text; return node; };
      const comparisonSchema = {
  "Grinder": [
    [
      "grinding",
      [
        "burr_type",
        "burr_size_mm",
        "burr_material",
        "adjustment",
        "brew_methods",
        "burr_upgrades"
      ]
    ],
    [
      "dosing",
      [
        "dosing_style",
        "dosing_modes",
        "dose_capacity",
        "dosing_output",
        "auto_stop",
        "controls",
        "bean_feed",
        "output"
      ]
    ],
    [
      "drive",
      [
        "speed_control",
        "rpm",
        "motor_type",
        "power",
        "cooling",
        "sensors",
        "bearings",
        "motor_details"
      ]
    ],
    [
      "cleaning",
      [
        "static_control",
        "retention_features",
        "chute",
        "burr_access",
        "noise_control"
      ]
    ],
    [
      "size_power",
      [
        "voltage",
        "plug",
        "battery",
        "body_material",
        "dimensions",
        "weight",
        "electrical_requirements",
        "amperage"
      ]
    ],
    [
      "ownership",
      [
        "model_revision",
        "condition",
        "condition_notes",
        "warranty",
        "included"
      ]
    ]
  ],
  "Espresso machine": [
    [
      "heating",
      [
        "boiler_system",
        "brew_boiler",
        "steam_system",
        "temperature_control",
        "temperature_range",
        "warm_up",
        "simultaneous_brew_steam",
        "boiler_capacity",
        "boiler_material"
      ]
    ],
    [
      "extraction",
      [
        "pump_type",
        "pump_details",
        "group_type",
        "group_count",
        "portafilter_mm",
        "basket_dose",
        "preinfusion",
        "flow_control",
        "shot_control",
        "pressure_control",
        "pressure_gauge",
        "controls",
        "portafilter_details",
        "integrated_grinder",
        "puck_preparation",
        "drink_presets"
      ]
    ],
    [
      "water_steam",
      [
        "water_source",
        "water_capacity",
        "plumbing_notes",
        "steam_wand",
        "hot_water",
        "drainage",
        "steam_hot_water",
        "milk_settings"
      ]
    ],
    [
      "size_power",
      [
        "voltage",
        "plug",
        "power",
        "battery",
        "energy_saving",
        "body_material",
        "dimensions",
        "clearance",
        "weight",
        "electrical_requirements",
        "amperage"
      ]
    ],
    [
      "ownership",
      [
        "condition",
        "condition_notes",
        "warranty",
        "included"
      ]
    ]
  ],
  "Roaster": [
    [
      "roasting",
      [
        "roaster_type",
        "batch_capacity_g",
        "batch_range",
        "heating_source",
        "roast_control",
        "roast_time",
        "hourly_output",
        "drum"
      ]
    ],
    [
      "roast_software",
      [
        "software",
        "computer",
        "tablet",
        "connectivity",
        "temperature_feedback",
        "automation"
      ]
    ],
    [
      "roast_handling",
      [
        "cooling_system",
        "chaff_collection",
        "exhaust",
        "assembly"
      ]
    ],
    [
      "size_power",
      [
        "voltage",
        "electrical_requirements",
        "power",
        "amperage",
        "max_draw",
        "blower_power",
        "plug",
        "dimensions",
        "weight"
      ]
    ],
    [
      "ownership",
      [
        "model_revision",
        "condition",
        "condition_notes",
        "warranty",
        "included"
      ]
    ]
  ]
};
      const differences = root.querySelector('[data-eo-differences]');
      let comparisonGroups = [];
      const filterComparison = () => {
        let visible = 0;
        comparisonGroups.forEach(({ body, rows }) => {
          let groupVisible = 0;
          rows.forEach(({ row, different }) => {
            row.hidden = differences.checked && !different;
            if (!row.hidden) groupVisible += 1;
          });
          body.hidden = groupVisible === 0;
          visible += groupVisible;
        });
        root.querySelector('[data-eo-row-count]').textContent = strings.expanded.row_count.replace('[count]', visible);
        root.querySelector('[data-eo-no-differences]').hidden = visible !== 0;
      };
      differences.addEventListener('change', filterComparison);
      openButton.addEventListener('click', () => {
        const selected = [...selection.values()];
        const table = document.createElement('table');
        const head = document.createElement('thead');
        const header = document.createElement('tr');
        header.append(cell('th', ''));
        selected.forEach(product => {
          const th = document.createElement('th');
          th.scope = 'col';
          const image = document.createElement('img');
          image.src = product.image; image.alt = product.title;
          const link = document.createElement('a');
          link.href = product.url; link.textContent = product.title;
          th.append(image, link); header.append(th);
        });
        head.append(header); table.append(head);
        comparisonGroups = [];
        const valueFor = (product, key) => product.attributes?.[key] ?? product.details?.[key];
        const hasValue = value => value !== null && value !== undefined && String(value).trim() !== '';
        const addGroup = (groupKey, entries) => {
          if (!entries.length) return;
          const body = document.createElement('tbody');
          const headingRow = document.createElement('tr');
          headingRow.className = 'eo-comparison__group';
          const heading = cell('th', strings.expanded.groups[groupKey]);
          heading.colSpan = selected.length + 1;
          headingRow.append(heading);
          body.append(headingRow);
          const rows = entries.map(([label, value]) => {
            const values = selected.map(value);
            const row = document.createElement('tr');
            const heading = cell('th', label);
            heading.scope = 'row';
            row.append(heading);
            values.forEach(text => row.append(cell('td', text)));
            body.append(row);
            return { row, different: new Set(values).size > 1 };
          });
          table.append(body);
          comparisonGroups.push({ body, rows });
        };
        addGroup('shopping', [
          [strings.price, p => p.price],
          [strings.brand, p => p.vendor],
          [strings.availability, p => p.available ? strings.available : strings.unavailable]
        ]);
        (comparisonSchema[selected[0].family] || []).forEach(([groupKey, keys]) => {
          const entries = keys
            .filter(key => selected.some(product => hasValue(valueFor(product, key))))
            .map(key => [strings.expanded.fields[key], product => {
              const value = valueFor(product, key);
              return hasValue(value) ? String(value) : strings.missing;
            }]);
          addGroup(groupKey, entries);
        });
        const body = document.createElement('tfoot');
        const links = document.createElement('tr'); links.append(cell('th', ''));
        selected.forEach(product => {
          const td = document.createElement('td'); const link = document.createElement('a');
          link.href = product.url; link.textContent = strings.details; td.append(link); links.append(td);
        });
        body.append(links); table.append(body);
        root.querySelector('[data-eo-comparison-table]').replaceChildren(table);
        filterComparison();
        dialog.showModal(); closeButton.focus();
      });
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => openButton.focus());
      root.querySelector('[data-eo-sort]').addEventListener('change', () => root.querySelector('[data-eo-filters]').requestSubmit());
      root.querySelectorAll('.eo-filter').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) root.querySelectorAll('.eo-filter').forEach(other => { if (other !== details) other.open = false; });
        });
      });
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape') root.querySelectorAll('.eo-filter[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
      });
      document.addEventListener('click', event => {
        if (!event.target.closest('.eo-filter')) root.querySelectorAll('.eo-filter[open]').forEach(details => { details.open = false; });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
